/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */

import {
// WEBSOCKET_CONNECT,
// WEBSOCKET_OPEN,
// WEBSOCKET_MESSAGE,
// WEBSOCKET_SEND,
// WEBSOCKET_CLOSED,
} from '@giantmachines/redux-websocket';


import {
  // REDUX_WEBSOCKET_BROKEN,
  REDUX_WEBSOCKET_CLOSED,
  REDUX_WEBSOCKET_CONNECT,
  REDUX_WEBSOCKET_MESSAGE,
  REDUX_WEBSOCKET_OPEN,
  REDUX_WEBSOCKET_SEND,
  ACTION_TYPE,
} from 'shared/redux/actions/actionTypes';

import {
  WEBSOCKET_STATUS_CONNECTING,
  WEBSOCKET_STATUS_CONNECTED,
  WEBSOCKET_STATUS_CLOSED,
  DIALOG,
  PATH,
} from 'shared/constants';
import { combineReducers } from 'redux';
// eslint-disable-next-line import/no-cycle
// import { initialState } from '../store';
// import { FV, PMT } from '../util/financeFormulas';
import handleReceiveMessage from './receive_message';
import fundFactsheetReducer from './fundFactsheet';
import assetAllocations from './assetAllocations';
import goalSummaryResults from './goalSummaryResults';
import ctaReducer from './ctaReducer';

const rootReducer = (state = [], action) => {
  switch (action.type) {
    /** Websocket/ Chat */
    case REDUX_WEBSOCKET_CONNECT:
      console.log('Websocket is connecting');
      return { ...state, websocketStatus: WEBSOCKET_STATUS_CONNECTING, connectCount: state.connectCount + 1 };
    case REDUX_WEBSOCKET_OPEN:
      console.log('Websocket connection open');
      return { ...state, websocketStatus: WEBSOCKET_STATUS_CONNECTED };
    case REDUX_WEBSOCKET_MESSAGE:
      return handleReceiveMessage(state, action);

    case ACTION_TYPE.GET_SAVED_INVESTOR_PROFILE:
      return {
        ...state,
        investorConversations: action.payload.conversation,
        stopThread: action.payload.stopThread,
        vars: action.payload.vars,
      };

    case ACTION_TYPE.GET_SAVED_RISK_ASSESSMENT:
      return {
        ...state,
        riskAssessment: action.payload.conversation,
        stopThread: action.payload.stopThread,
        vars: action.payload.vars,
      };

    case ACTION_TYPE.GET_SAVED_INVESTMENT_PREFERENCE:
      return {
        ...state,
        investmentPreference: action.payload.conversation,
        stopThread: action.payload.stopThread,
        vars: action.payload.vars,
      };

    // saving the conversation before sending to botkit
    case ACTION_TYPE.PRE_MESSAGE_SEND:
      // console.log(action.payload);
      return Object.assign({}, state, {

        // saving investor profile step data before sending to botkit
        PreInvestorProfile: (action.payload.dialog === DIALOG.INVESTOR_PROFILE)
          ? [...state.investorConversations, action.payload]
          : state.investorConversations,

        // saving risk assessment step data before sending to botkit
        PreRiskAssessment: (action.payload.dialog === DIALOG.RISK_ASSESSMENT)
          ? [...state.riskAssessment, action.payload]
          : state.riskAssessment,

        // saving investment preference step data before sending to botkit
        PreInvestmentPreference: (action.payload.dialog === DIALOG.INVESTMENT_PREFERENCE)
          ? [...state.investmentPreference, action.payload]
          : state.investmentPreference,

        // PreCallToAction: (action.payload.dialog === DIALOG.CALL_TO_ACTION)
        //   ? [...state.callToAction, action.payload]
        //   : state.callToAction,
      });

    case REDUX_WEBSOCKET_SEND:
      // console.log('Send message: ', action.payload);
      return Object.assign({}, state, {
        investorConversations: action.payload.dialog === DIALOG.INVESTOR_PROFILE
          ? [...state.investorConversations, action.payload] : [...state.investorConversations],
        riskAssessment: action.payload.dialog === DIALOG.RISK_ASSESSMENT
          ? [...state.riskAssessment, action.payload] : [...state.riskAssessment],
        investmentPreference: action.payload.dialog === DIALOG.INVESTMENT_PREFERENCE
          ? [...state.investmentPreference, action.payload] : [...state.investmentPreference],
        callToAction: action.payload.dialog === DIALOG.CALL_TO_ACTION
          ? [...state.callToAction, action.payload] : [...state.callToAction],
        isBotTyping: action.payload.typingDelay || 0,
      });
    case REDUX_WEBSOCKET_CLOSED:
      console.log('Websocket connection closed');
      return { ...state, websocketStatus: WEBSOCKET_STATUS_CLOSED };
    case 'SWITCH_LANGUAGE':
      return { ...state, language: action.payload.language };
    case ACTION_TYPE.CLEAR_CONVERSATION:
      return {
        ...state,
        investorConversations: [],
        riskAssessment: [],
        investmentPreference: [],
        callToAction: [],
      };

    case ACTION_TYPE.SAVE_STEP_STATUS:
      return { ...state, stepStatus: action.payload };

    case ACTION_TYPE.RESET_BOT_TYPING:
      return { ...state, isBotTyping: 0 };
    case ACTION_TYPE.UPDATE_SUMMARY:
      return { ...state, summary: { ...state.summary, ...action.payload } };
    case ACTION_TYPE.UPDATE_STEP:
      return { ...state, step: action.payload };
    case ACTION_TYPE.SAVE_USER_INFO:
      return { ...state, userInfo: action.payload };
    case ACTION_TYPE.GENERATE_CHANNEL:
      return { ...state, user: action.payload };
    case ACTION_TYPE.CLEAR_CONVERSATION_HISTORY:
      return {
        ...state,
        investorConversations: action.payload.dialog === DIALOG.INVESTOR_PROFILE ? [] : state.investorConversations,
        riskAssessment: action.payload.dialog === DIALOG.RISK_ASSESSMENT ? [] : state.riskAssessment,
        investmentPreference: action.payload.dialog === DIALOG.INVESTMENT_PREFERENCE ? [] : state.investmentPreference,
        callToAction: action.payload.dialog === DIALOG.CALL_TO_ACTION ? [] : state.callToAction,
        stopThread: action.payload.stopThread,
        vars: action.payload.vars,
        redo: action.payload.redo,
      };
    case ACTION_TYPE.SET_REDO:
      return {
        ...state,
        redo: action.payload,
      };
    case ACTION_TYPE.REFRESH_USER:
      return {
        ...state,
        investorConversations: [],
        riskAssessment: [],
        investmentPreference: [],
        callToAction: [],
        stopThread: null,
        vars: null,
        stepStatus: [{
          step: DIALOG.INVESTOR_PROFILE,
          number: 1,
          active: true,
          status: null,
          title: 'journey.step1Title',
          desc: 'journey.step1Desc',
          path: PATH.INVESTOR_PROFILE,
        },
        {
          step: DIALOG.RISK_ASSESSMENT,
          number: 2,
          active: false,
          status: null,
          title: 'journey.step2Title',
          desc: 'journey.step2Desc',
          path: PATH.RISK_ASSESSMENT,
        },
        {
          step: DIALOG.INVESTMENT_PREFERENCE,
          number: 3,
          active: false,
          status: null,
          title: 'journey.step3Title',
          desc: 'journey.step3Desc',
          path: PATH.INVESTMENT_PREFERENCE,
        }],
        summary: {},
        CMAClassification: 'CMAClassification.Qualified',
        isStartStep: false,
        redo: '',
      };
    case ACTION_TYPE.ACTIVATE_START_STEP:
      return { ...state, isStartStep: true };
    case ACTION_TYPE.UPDATE_INPUT_COMPONENT:
      return { ...state, inputComponent: action.payload };
    default:
      return state;
  }
};

export default combineReducers({
  rootReducer,
  fundFactsheetReducer,
  assetAllocations,
  goalSummaryResults,
  ctaReducer,
});
